import { Button, Flex, Typography, notification } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { IoDownloadOutline } from 'react-icons/io5';
import styles from './MFABackupCodes.module.css';

const { Text } = Typography;

interface MFABackupCodesProps {
  codes: string[];
}

export const MFABackupCodes = ({ codes }: MFABackupCodesProps) => {
  const codesText = codes.join('\n');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codesText);
      notification.success({ title: 'Backup codes copied to clipboard' });
    } catch {
      notification.error({ title: 'Failed to copy backup codes' });
    }
  };

  const handleDownload = () => {
    const blob = new Blob([codesText], { type: 'text/plain;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'backup-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Flex vertical gap={12}>
      <div className={styles.codeGrid}>
        {codes.map((code) => (
          <div key={code} className={styles.codeWrapper}>
            <Text code className={styles.code}>
              {code}
            </Text>
          </div>
        ))}
      </div>

      <Flex gap={8}>
        <Button icon={<CopyOutlined />} onClick={handleCopy}>
          Copy
        </Button>
        <Button icon={<IoDownloadOutline />} onClick={handleDownload}>
          Download
        </Button>
      </Flex>
    </Flex>
  );
};
